// extracted by mini-css-extract-plugin
module.exports = {"container":"footer_container__MlVoj","footerLink":"footer_footerLink__ZL9VG"};